function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { noop } from 'motion-utils';
import { addToQueue } from './queue.mjs';

var ViewTransitionBuilder = /*#__PURE__*/function () {
  function ViewTransitionBuilder(update) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ViewTransitionBuilder);

    this.currentTarget = "root";
    this.targets = new Map();
    this.notifyReady = noop;
    this.readyPromise = new Promise(function (resolve) {
      _this.notifyReady = resolve;
    });
    this.update = update;
    this.options = _objectSpread({
      interrupt: "wait"
    }, options);
    addToQueue(this);
  }

  _createClass(ViewTransitionBuilder, [{
    key: "get",
    value: function get(selector) {
      this.currentTarget = selector;
      return this;
    }
  }, {
    key: "layout",
    value: function layout(keyframes, options) {
      this.updateTarget("layout", keyframes, options);
      return this;
    }
  }, {
    key: "new",
    value: function _new(keyframes, options) {
      this.updateTarget("new", keyframes, options);
      return this;
    }
  }, {
    key: "old",
    value: function old(keyframes, options) {
      this.updateTarget("old", keyframes, options);
      return this;
    }
  }, {
    key: "enter",
    value: function enter(keyframes, options) {
      this.updateTarget("enter", keyframes, options);
      return this;
    }
  }, {
    key: "exit",
    value: function exit(keyframes, options) {
      this.updateTarget("exit", keyframes, options);
      return this;
    }
  }, {
    key: "crossfade",
    value: function crossfade(options) {
      this.updateTarget("enter", {
        opacity: 1
      }, options);
      this.updateTarget("exit", {
        opacity: 0
      }, options);
      return this;
    }
  }, {
    key: "updateTarget",
    value: function updateTarget(target, keyframes) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var currentTarget = this.currentTarget,
          targets = this.targets;

      if (!targets.has(currentTarget)) {
        targets.set(currentTarget, {});
      }

      var targetData = targets.get(currentTarget);
      targetData[target] = {
        keyframes: keyframes,
        options: options
      };
    }
  }, {
    key: "then",
    value: function then(resolve, reject) {
      return this.readyPromise.then(resolve, reject);
    }
  }]);

  return ViewTransitionBuilder;
}();

function animateView(update) {
  var defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new ViewTransitionBuilder(update, defaultOptions);
}

export { ViewTransitionBuilder, animateView };